import router from '@/router';
import { UserAssignedToCall } from '@/shared/events/user-assigned-to-call';
import { User } from '@/shared/user';
import store from '@/store';

async function handleUserAssignedToCall(data: UserAssignedToCall): Promise<void> {
    const currentUser: User | null = store.getters['user/user'];

    if (currentUser == null || router.currentRoute.name !== 'call-list') {
        return;
    }

    await store.dispatch('calls/loadMyCallsAsync');
}

export default handleUserAssignedToCall;
